
const SET_ATTACHMENT = "SET_ATTACHMENT";
const UPLOAD_ATTACHMENTS = "UPLOAD_ATTACHMENTS";
const REMOVE_ATTACHMENT = "REMOVE_ATTACHMENT";
const REMOVE_ALL_ATTACHMENTS = "REMOVE_ALL_ATTACHMENTS";

export {
    SET_ATTACHMENT,
    UPLOAD_ATTACHMENTS,
    REMOVE_ATTACHMENT,
    REMOVE_ALL_ATTACHMENTS
};
